import { Flex } from 'antd';
import { Button, Form } from 'antd/lib';
import { utils, writeFile } from 'xlsx';
import { useEffect } from 'react';

export function DriverEventImportForm(props: any) {
  useEffect(() => {
    props.form.setFieldValue('uploadFile', null);
  }, [props.form]);

  const onDownloadTemplateClick = () => {
    const template = [
      {
        日期: '2025-09-08',
        司機代號: '代號A',
        調整金額: '1000',
        備註: '我是測試',
      },
    ];

    const wb = utils.book_new();
    const ws = utils.json_to_sheet(template);
    utils.book_append_sheet(wb, ws, '司機事件');
    writeFile(wb, '司機事件範本.xlsx');
  };

  const onFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    props.form.setFieldValue('uploadFile', file);
  };

  return (
    <Flex vertical gap={8} align="start">
      <Button onClick={onDownloadTemplateClick} type="link">
        下載範本
      </Button>

      <Form.Item label="請上傳司機事件" rules={[{ required: true }]}>
        <input type="file" accept=".xlsx" onChange={onFileChange} />
      </Form.Item>

      <Form form={props.form} autoComplete="off" preserve={false}></Form>
    </Flex>
  );
}
